/**
 * AdLevelsTab — вкладка «По уровням» раздела «Реклама»
 * ======================================================
 *
 * Две вьюхи одной когорты: таблица по всем уровням и динамика выбранного
 * уровня / дня жизни по периодам регистрации. Выбор вьюхи переживает
 * перезагрузку.
 */

import React from 'react';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { ToggleGroup, ToggleGroupItem } from '../../ui/toggle-group';
import { AdLevelsWidget } from './AdLevelsWidget';
import { AdLevelsTrendWidget } from './AdLevelsTrendWidget';

const VIEW_TABLE = 'table';
const VIEW_TREND = 'trend';

export function AdLevelsTab() {
  const [view, setView] = useLocalStorage('ads-levels:view', VIEW_TABLE);
  const isTrend = view === VIEW_TREND;

  return (
    <div className="space-y-3">
      <ToggleGroup type="single" size="sm" value={isTrend ? VIEW_TREND : VIEW_TABLE} onValueChange={(v) => v && setView(v)}>
        <ToggleGroupItem value={VIEW_TABLE} className="text-xs px-3">
          Таблица по уровням
        </ToggleGroupItem>
        <ToggleGroupItem value={VIEW_TREND} className="text-xs px-3">
          Динамика уровня / дня жизни
        </ToggleGroupItem>
      </ToggleGroup>
      {isTrend ? <AdLevelsTrendWidget /> : <AdLevelsWidget />}
    </div>
  );
}

export default AdLevelsTab;
